import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';
import dashboard from '../../assets/img/landingPage/flow/flow-00.png';

import features_1 from '../../assets/img/landingPage/flow/flow-01.png'
import features_2 from '../../assets/img/landingPage/flow/flow-02.png'
import features_3 from '../../assets/img/landingPage/flow/flow-03.png'

import icon_1 from '../../assets/img/landingPage/flow/icn_Flow-01.png'
import icon_2 from '../../assets/img/landingPage/flow/icn_Flow-02.png'
import icon_3 from '../../assets/img/landingPage/flow/icn_Flow-03.png'

import logo from '../../assets/img/logos/AVAP_Flow-neg.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const FlowProduct = () => {
    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroSolutions" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Flow"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Unified API Flows. Smarter, Faster Queries.</h1>
                    <p className="fl-subtitle">
                        Design and implement unified data flows with Gen-AI-powered intelligence.

                    </p>
                    {/*<a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>*/}

                    <img
                        src={dashboard}
                        alt=" Modern API Design with OAS and A2ML (AVAP API Modeling Language) 
                        for Scalable Architecture"
                        className="img-fluid mt-4"
                        style={{ 
                            width: '90%', 
                            maxWidth: '900px', 
                            height: 'auto' ,
                            paddingTop: "100px" }}
                    />   

                </section>

                {/* Powerful API Platform */}
                <section id= "subtitleSection" className="text-center pb-5">
                    <div className="row">
                        <div className="col">
                            {/* <p className="fl-subtitle mb-3">
                                Titulo
                            </p> */}
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            {/*<p className="fl-subtitle mb-3">
                                Design and implement unified data flows with Gen-AI-powered intelligence
                            </p>*/}
                            <p className="fl-text fl-txt-container-s">
                                AVAP Flow is a powerful tool within AVAP Framework that allows developers to unify multiple APIs into a single, queryable data flow no middleware required. With Gen-AI-assisted schema creation and optimization, AVAP Flow simplifies the way you aggregate, normalize, and expose data from different APIs, enabling faster development and enhanced performance. It supports both OAS and A2ML (AVAP API Modeling Language)-based APIs, providing flexibility and precision in modern integration architectures.
                            </p>
                        </div>
                    </div>

                </section>

                {/* Features */}
                            <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_1} alt="icon_1" />
                                <p>Unified API Query Layer</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_2} alt="icon_2" />
                                <p>Gen-AI Schema Modeling</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_3} alt="icon_3" />
                                <p>Real-Time API Flow Composition</p>
                            </div>
                        </div>
                    </div>
                </section> 

                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Image of a code repository representing the organization and management of code for version control"
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">

                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">AI-Powered Schema Generation & Optimization</h3>
                            <p className="fl-text">
                            Leverage Gen-AI to automatically generate, refine, and optimize schemas based on your connected APIs. Reduce time spent on manual mapping while improving accuracy and query performance across your API ecosystem.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Unified Access to Distributed APIs</h3>
                            <p className="fl-text">
                            Expose data from multiple AVAP APIs through a single flow endpoint. Eliminate point-to-point integrations and simplify data access for frontend teams, mobile apps, or external partners.
                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Image of version tracking system in AVAP API Source Control."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>
                    </div>

                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>



                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Custom Flow Composition with A2ML Fragments
                            </h3>
                            <p className="fl-text">
                            Use AVAP’s A2ML (AVAP API Modeling Language) to define modular, reusable flow definitions that allow you to build complex API compositions with clarity and consistency, enabling real-time insights and scalable architectures.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Accelerate Frontend Development
                                </p>
                                <p className="fl-text">
                                 Expose only the data your apps need with flexible, streamable APIs, reducing over-fetching and under-fetching issues typical of traditional REST endpoints.
                                    <br />
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Simplify Data Access Across APIs
                                </p>
                                <p className="fl-text">
                                Unify multiple endpoints into a single flow, eliminating redundant API calls and making it easier for teams to consume data in a consistent, structured format.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Boost Developer Productivity with Gen-AI
                                </p>
                                <p className="fl-text">
                                Automatically suggest field mappings, optimize query paths, and identify potential conflicts using Gen-AI, allowing teams to design and deploy flow-based APIs faster and with greater confidence.

                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default FlowProduct;
